import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Demo credentials
  const DEMO_USERS = [
    { email: 'demo@crypto.com', password: 'demo123', name: 'Demo User' },
    { email: 'test@crypto.com', password: 'test123', name: 'Test User' },
    { email: 'user@crypto.com', password: 'user123', name: 'Crypto User' },
  ];

  useEffect(() => {
    // Check if user is logged in on app start
    const storedUser = localStorage.getItem('demoUser');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (email, password) => {
    return new Promise((resolve, reject) => {
      // Simulate API delay
      setTimeout(() => {
        const foundUser = DEMO_USERS.find(
          (u) => u.email === email && u.password === password
        );

        if (foundUser) {
          const userSession = {
            email: foundUser.email,
            name: foundUser.name,
            uid: Math.random().toString(36).substr(2, 9),
          };

          setUser(userSession);
          localStorage.setItem('demoUser', JSON.stringify(userSession));
          localStorage.setItem('userEmail', userSession.email);
          localStorage.setItem('userId', userSession.uid);
          resolve(userSession);
        } else {
          reject(new Error('Invalid email or password'));
        }
      }, 1000);
    });
  };

  const signup = (email, password) => {
    return new Promise((resolve) => {
      // For demo purposes, any signup is successful
      setTimeout(() => {
        const newUser = {
          email: email,
          name: email.split('@')[0],
          uid: Math.random().toString(36).substr(2, 9),
        };

        setUser(newUser);
        localStorage.setItem('demoUser', JSON.stringify(newUser));
        localStorage.setItem('userEmail', newUser.email);
        localStorage.setItem('userId', newUser.uid);
        resolve(newUser);
      }, 1000);
    });
  };

  const logout = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        setUser(null);
        localStorage.removeItem('demoUser');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userId');
        resolve();
      }, 500);
    });
  };

  const value = {
    user,
    login,
    signup,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
